<main>
  <loading-overlay [isLoading]="isLoading()" />
  <p-toast position="bottom-right" key="br"></p-toast>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Locations_Title' | translateWF: 'Warehouse Locations' }}</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Locations_Add_Site' | translateWF: 'Add Site'" icon="pi pi-plus" (onClick)="openLocationModal()" />
        </div>
      </div>
    </div>

    <p-card data-variant="compact">
      <p-treeTable [value]="treeNodes()" [scrollable]="true" scrollHeight="calc(100vh - 250px)" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Locations_Code' | translateWF: 'Location Code' }}</th>
            <th>{{ 'Locations_Name' | translateWF: 'Name' }}</th>
            <th>{{ 'Locations_Type' | translateWF: 'Type' }}</th>
            <th>{{ 'Locations_Storable' | translateWF: 'Storable' }}</th>
            <th>{{ 'Common_Actions' | translateWF: 'Actions' }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr>
            <td>
              <p-treeTableToggler [rowNode]="rowNode" />
              <span class="font-mono">{{ rowData.code }}</span>
            </td>
            <td>
              {{ localHelperTranslate.getLocalizedValue(rowData.name) }}
            </td>
            <td>
              <p-tag [value]="getLocationTypeName(rowData.type)" [severity]="rowData.type === LocationType.Bin ? 'success' : 'secondary'" />
            </td>
            <td>
              <i [class]="rowData.isStorable ? 'pi pi-check text-green-500' : 'pi pi-times text-red-500'" [pTooltip]="getStorableText(rowData.isStorable)"></i>
            </td>
            <td class="!text-end">
              <p-button
                icon="pi pi-plus"
                variant="text"
                severity="success"
                [pTooltip]="'Locations_Add_Child' | translateWF: 'Add Child Location'"
                (onClick)="onAddChildLocation($event, rowData)"
                [disabled]="rowData.type === LocationType.Bin"
              />
              <p-button icon="pi pi-pencil" variant="text" [pTooltip]="'Common_Edit' | translateWF: 'Edit'" (onClick)="onEditLocation($event, rowData)" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-8">
              {{ 'Common_No_Data' | translateWF: 'No locations found' }}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </p-card>
  </div>
</main>
<p-confirmdialog key="locationsConfirm" styleClass="modal_small" />
